<template>
	<div id="butterflyGallery">
		<div v-if="getUser()">
			<b-form-group >
				<b-form-radio-group
				id="btn-radios-2"
				v-model="selected"
				:options="options"
				buttons
				button-variant="outline-primary"
				size="lg"
				name="radio-btn-outline"
				></b-form-radio-group>
			</b-form-group>
			<h3>Butterfly Gallery</h3>
			<br>
			<div v-if="selected == 'all'">
				<b-row class="noselect text-center" style="cursor:pointer">
					<b-col v-for="butterfly of butterflies.filter(thisUser).slice().reverse()" cols="3" v-bind:key="butterfly['.key']"
					>
					<b-card
					style="max-width: 20rem;"
					class="mb-2 onHover"
					@click="toButterfly(butterfly['.key'])" v-if="!(butterfly.url==='')">
					<b-img-lazy :src="butterfly.url" fluid alt="No image" class="mb-2"></b-img-lazy>
					<b-card-text class="text-center" >
						{{butterfly.scientificName}}
					</b-card-text>
				</b-card>

				<b-card
				style="max-width: 20rem;"
				class="mb-2 onHover"
				@click="toButterfly(butterfly['.key'])" v-else>
				<img src="../assets/unknown.png" fluid alt="No image" class="mb-2 responsive">
				<b-card-text class="text-center" >
					{{butterfly.scientificName}}
				</b-card-text>
			</b-card>
		</b-col>
	</b-row>
</div>

<div v-else-if="selected == 'current'">
	<b-row class="noselect text-center" style="cursor:pointer">
		<b-col v-for="butterfly of currentlyInWing(butterflies.filter(thisUser).slice().reverse())" cols="3" v-bind:key="butterfly['.key']"
		>
		<b-card
		style="max-width: 20rem;"
		class="mb-2 onHover"
		@click="toButterfly(butterfly['.key'])" v-if="!(butterfly.url==='')">
		<b-img-lazy :src="butterfly.url" fluid alt="No image" class="mb-2"></b-img-lazy>
		<b-card-text class="text-center" >
			{{butterfly.scientificName}}
		</b-card-text>
	</b-card>

	<b-card
	style="max-width: 20rem;"
	class="mb-2 onHover"
	@click="toButterfly(butterfly['.key'])" v-else>
	<img src="../assets/unknown.png" fluid alt="No image" class="mb-2 responsive">
	<b-card-text class="text-center" >
		{{butterfly.scientificName}}
	</b-card-text>
</b-card>
</b-col>
</b-row>
</div>

</div>

<div v-else>
	<b-form-group >
		<b-form-radio-group
		id="btn-radios-2"
		v-model="selected"
		:options="options"
		buttons
		button-variant="outline-primary"
		size="lg"
		name="radio-btn-outline"
		></b-form-radio-group>
	</b-form-group>
	<h3>Butterfly Gallery</h3>
	<br>
	<div v-if="selected == 'all'">
		<b-row class="noselect text-center" style="cursor:pointer">
			<b-col v-for="butterfly of butterflies.slice().reverse()" cols="3" v-bind:key="butterfly['.key']"
			>
			<b-card
			style="max-width: 20rem;"
			class="mb-2 onHover"
			@click="toButterfly(butterfly['.key'])" v-if="!(butterfly.url==='')">
			<b-img-lazy :src="butterfly.url" fluid alt="No image" class="mb-2"></b-img-lazy>
			<b-card-text class="text-center" >
				{{butterfly.scientificName}}
			</b-card-text>
		</b-card>

		<b-card
		style="max-width: 20rem;"
		class="mb-2 onHover"
		@click="toButterfly(butterfly['.key'])" v-else>
		<img src="../assets/unknown.png" fluid alt="No image" class="mb-2 responsive">
		<b-card-text class="text-center" >
			{{butterfly.scientificName}}
		</b-card-text>
	</b-card>
</b-col>
</b-row>
</div>

<div v-else-if="selected == 'current'">
	<b-row class="noselect text-center" style="cursor:pointer">
		<b-col v-for="butterfly of currentlyInWing(butterflies.slice().reverse())" cols="3" v-bind:key="butterfly['.key']"
		>
		<b-card
		style="max-width: 20rem;"
		class="mb-2 onHover"
		@click="toButterfly(butterfly['.key'])" v-if="!(butterfly.url==='')">
		<b-img-lazy :src="butterfly.url" fluid alt="No image" class="mb-2"></b-img-lazy>
		<b-card-text class="text-center" >
			{{butterfly.scientificName}}
		</b-card-text>
	</b-card>

	<b-card
	style="max-width: 20rem;"
	class="mb-2 onHover"
	@click="toButterfly(butterfly['.key'])" v-else>
	<img src="../assets/unknown.png" fluid alt="No image" class="mb-2 responsive">
	<b-card-text class="text-center" >
		{{butterfly.scientificName}}
	</b-card-text>
</b-card>
</b-col>
</b-row>
</div>

</div>

</div>
</template>

<style>
#butterflyGallery {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	padding: 50px 50px 50px 50px;
}

.responsive {
	width: 100%;
	height: auto;
}

.onHover:hover{
	opacity: 0.8;
	color: black;
}
</style>

<script>
import { butterflyRef } from '../firebase';
import { shipmentsRef } from '../firebase';
import { batchRef } from '../firebase';
export default {
	name: 'butterflies',
	data () {
		return {
			butterflies: [],
			shipments: [],
			batches: [],
			selected: 'current',
			options: [
			{ text: 'Current', value: 'current' },
			{ text: 'All', value: 'all' },
			]
		}
	},
	firebase: {
		butterflies: butterflyRef,
		shipments: shipmentsRef,
		batches: batchRef
	},
	methods: {
		toButterfly(key){
			this.$router.push({name:'ButterflyView', params: {id: key}})
		},
		estimatedInFlight(butterfly){
			if(butterfly.longevity === '' || parseInt(butterfly.longevity) == 0){
				return 0;
			}

			var counter = 0;
			for(let i = 0; i<this.batches.length; i++){
				if(this.batches[i].speciesN == butterfly.scientificName){
					for(let j = 0; j<this.shipments.length; j++){
						if(this.shipments[j]['.key']==this.batches[i].id){
							if(this.diffDate(new Date(this.shipments[j].arrivalDate), new Date()) <= parseInt(butterfly.longevity)){

								counter += parseInt(this.batches[i].released);
							}
						}
					}
				}
			}
			return counter;
		},
		currentlyInWing(butterflies){
			var bflyList = [];
			for(let i =0; i<butterflies.length; i++){
				if(this.estimatedInFlight(butterflies[i])>0){
					bflyList.push(butterflies[i]);
				}
			}
			return bflyList;
		},
		diffDate(d1, d2){
			const date1 = new Date(d1);
			const date2 = new Date(d2);
			const diffTime = date2 - date1;
			const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
			return diffDays;
		},
		getUser(){
			return this.$parent.activeUser?this.$parent.activeUser.name:'';
		},
		thisUser(butterfly){
			return (butterfly.user == this.getUser() || this.getUser() == 'Reiman Gardens')?butterfly:null
		}
	}
}
</script>